// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__wTvl0","subheader":"ReorderModal_subheader__2Dc3i","listWrap":"ReorderModal_listWrap__3koWC"};